import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

const MainSection = ({ children, sidebarToggled, isIFrame }) => {
  const classes = classnames('main-content', {
    'sidebar-toggle': sidebarToggled,
    fullScreen: isIFrame
  });

  return <section className={classes}>{children}</section>;
};

function mapStateToProps(state) {
  return {
    sidebarToggled: state.ui.sidebarToggled
  };
}

export default connect(mapStateToProps)(MainSection);
